import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const UserForm = ({ user, onClose }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user) {
            setFormData({
                email: user.email,
                password: ''
            });
        }
    }, [user]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        const validationErrors = [];
        if (!formData.email) {
            validationErrors.push('Email is required');
        }
        if (!user && !formData.password) {
            validationErrors.push('Password is required for new users');
        }
        if (formData.password && formData.password.length < 8) {
            validationErrors.push('Password must be at least 8 characters long');
        }

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setErrors([]);

        const payload = {
            email: formData.email
        };

        if (formData.password) {
            payload.password = formData.password;
        }

        try {
            const url = user
                ? `/api/users/${user.id}`
                : '/api/users/register';

            const response = await fetch(url, {
                method: user ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (response.ok) {
                onClose();
            } else {
                if (data.errors && Array.isArray(data.errors)) {
                    setErrors(data.errors);
                } else if (data.error && typeof data.error === 'string') {
                    setErrors([data.error]);
                } else if (data.message && typeof data.message === 'string') {
                    setErrors([data.message]);
                } else {
                    setErrors(['An unexpected error occurred']);
                }
            }
        } catch (error) {
            setErrors(['Failed to connect to the server. Please try again later.']);
            console.error('API Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{user ? 'Edit User' : 'Add User'}</h2>
                    <button className="close-button" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    {errors.length > 0 && (
                        <div className="error">
                            <ul>
                                {errors.map((error, index) => (
                                    <li key={index}>{error}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">
                            Password {user && '(Leave blank to keep current)'}
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required={!user}
                            minLength={8}
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="submit-button"
                            disabled={loading}
                        >
                            {loading ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserForm; 